import { CONSULTANT_ROLES } from '@/common/constants/consultantRoles';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useState } from 'react';
import { RESULT_OPTIONS } from '../constants/resultOptions';
import { SELECT_DEFAULT_OPTION } from '../constants/selectDefaultOption';

const useSearchBox = ({ handleSearchCallback }) => {
	const results = [
		SELECT_DEFAULT_OPTION,
		...RESULT_OPTIONS.map((resultOption) => ({
			label: resultOption,
			value: resultOption,
		})),
	];

	const { options, filterUsersByRoles } = useCommonDataContext();

	const [selectedMarkets, setSelectedMarkets] = useState([]);
	const [selectedConsultants, setSelectedConsultants] = useState([]);
	const [selectedResult, setSelectedResult] = useState(results[0]);

	const marketOptions = options.marketsOptions;
	const consultantOptions = filterUsersByRoles(CONSULTANT_ROLES, true);

	const handleSearch = () => {
		const payload = {
			marketsIds: selectedMarkets.map((market) => market.value),
			consultantsIds: selectedConsultants.map((cons) => cons.value),
			selectedResultValue: selectedResult.value,
		};

		handleSearchCallback(payload);
	};

	return {
		marketOptions,
		selectedMarkets,
		setSelectedMarkets,
		consultantOptions,
		selectedConsultants,
		setSelectedConsultants,
		results,
		selectedResult,
		setSelectedResult,
		handleSearch,
	};
};

export default useSearchBox;
